document.addEventListener("DOMContentLoaded", function () {
    const faq = document.querySelector(".faq");
    const faqItems = faq ? faq.querySelectorAll(".single-faq") : [];

    if (faqItems.length > 0) {
        faqItems.forEach((item) => {
            item.addEventListener("click", function () {
                const isActive = item.classList.contains("active");

                faqItems.forEach((i) => {
                    i.classList.remove("active");
                });

                if (!isActive) {
                    item.classList.add("active");
                }
            });
        });
    }
});